var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('p',{staticClass:"comment"},[_vm._v(_vm._s(_vm.content))]),_c('p',[_vm._v(_vm._s(_vm.ratingStars))]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.reviewName))]),_c('span',[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }